import React, { Component } from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import { browserHistory } from 'react-router';

import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';

import NavigationBack from 'material-ui/svg-icons/navigation/arrow-back';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';
import FilterIcon from 'material-ui/svg-icons/content/filter-list';
import SortByAlphaIcon from 'material-ui/svg-icons/av/sort-by-alpha';
import SearchIcon from 'material-ui/svg-icons/action/search';
import Dialog from 'material-ui/Dialog';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

import NotificationBadge from '../Notification/Badge';
import EventBadge from '../Event/Badge';

import ToolbarMenu from './ToolbarMenu';

/**
 *
 * Generic toolbar for UI components like lists and detail views
 *
 * @prop function toggleSearchMode, function to enable/disable search mode
 * @prop bool searchable
 * @prop string title
 * @prop array|object actions, MenuItem(s) to show in the context menu
 * @prop array|object sortOptions, simple object or collection containing label and value.
 * @example
 *    [
 *      {label: "First name", value: 'firstName'},
 *      {label: "Last name", value: 'lastName'}
 *    ]
 * @prop function sortAction
 */

const style = {
    toolbar: {
        width: '100%',
        display: 'flex',
        minHeight: '64px',
        paddingLeft: '24px',
        paddingRight: '24px',
        top: 0,
        position: 'fixed',
        zIndex: 1100,
        boxSizing: 'border-box',
        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
        boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)',
        borderRadius: 0,
    },
    toolbarGroup1 : {
        marginTop: '8px',
        marginRight: '8px',
        marginLeft: '-16px',
        boxSizing: 'border-box',
        display: 'inline-block',
        font: 'inherit',
        cursor: 'pointer',
        textDecoration: 'none',
        outline: 'none',
        position: 'relative',
        fontSize: 0,
    },
    toolbarGroup2 : {
        marginTop: '8px',
        marginRight: '-16px',
        marginLeft: 'auto',
        position: 'relative',
        textAlign: 'right',
    },
    toolbarTitle : {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        letterSpacing: 0,
        fontSize: '26px',
        color: '#FFF',
        lineHeight: '64px',
        boxFlex: 1,
        margin: 0,
        paddingTop: 0,
    },
    svg : {
        fill: '#FFF !important',
    },
    sortDialog: {
        width: '300px'
    },
    sortOption: {
        padding: ' 12px 0'
    }
};

class AppToolbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortDialog: {
                open: false,
                selected: ''
            },
            filterDialog: {
                open: false,
                selected: ''
            },
        };
    }

    componentDidMount() {
        this.onSortByItemChange = this.onSortByItemChange.bind(this);
        this.onFilterByItemChange = this.onFilterByItemChange.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    render() {
        const leftIconButton = (this.props.backButton
            ? (
                <IconButton onClick={this.goBack} iconStyle={style.svg} >
                    <NavigationBack />
                </IconButton>
            )
            : (
                <IconButton
                    iconStyle={style.svg}
                    onMouseUp={this.context.toggleLeftNav}
                    onTouchEnd={this.context.toggleLeftNav}
                >
                    <NavigationMenu />
                </IconButton>
            )
        );

        return (
            <Toolbar style={style.toolbar} className="toolbar" >
                <ToolbarGroup
                    className="toolbar-group"
                    style={style.toolbarGroup1}
                    firstChild={true}
                >
                    {leftIconButton}
                </ToolbarGroup>
                <div className="toolbar-title" >
                    {this.props.title ? <ToolbarTitle style={style.toolbarTitle} text={this.props.title} /> : ''}
                </div>
                <ToolbarGroup className="toolbar-group" style={style.toolbarGroup2} >
                    {!!this.props.searchable && (
                        <IconButton
                            iconStyle={style.svg}
                            onMouseUp={this.props.toggleSearchMode}
                            onTouchEnd={this.props.toggleSearchMode}
                        >
                            <SearchIcon />
                        </IconButton>
                    )}
                    {!!this.props.sortOptions && (
                        <IconButton iconStyle={style.svg} onClick={this.onDialogOpen.bind(this, 'sortDialog')} >
                            <SortByAlphaIcon />
                        </IconButton>
                    )}
                    {this.props.sortOptions && (
                        <Dialog
                            title="Sort by"
                            modal={false}
                            open={this.state.sortDialog.open}
                            onRequestClose={this.onDialogClose.bind(this, 'sortDialog')}
                            contentStyle={style.sortDialog}
                        >
                            <RadioButtonGroup
                                name="sortBy"
                                valueSelected={this.state.sortDialog.selected}
                                onChange={this.onSortByItemChange}
                            >
                                {this.props.sortOptions.map(({value, label}, i) => (
                                    <RadioButton key={i} value={value} label={label} style={style.sortOption} />
                                ))}
                            </RadioButtonGroup>
                        </Dialog>
                    )}
                    {this.props.filterOptions && (
                        <IconButton iconStyle={style.svg} onClick={this.onDialogOpen.bind(this, 'filterDialog')}>
                            <FilterIcon />
                        </IconButton>
                    )}
                    {!!this.props.filterOptions && (
                        <Dialog
                            title="Filter by"
                            modal={false}
                            open={this.state.filterDialog.open}
                            onRequestClose={this.onDialogClose.bind(this, 'filterDialog')}
                            contentStyle={style.filterDialog}
                        >
                            <RadioButtonGroup
                                name="filterBy"
                                valueSelected={this.state.filterDialog.selected}
                                onChange={this.onFilterByItemChange}
                            >
                                {this.props.filterOptions.map((option, i) => (<RadioButton key={i} {...option} style={style.sortOption} />))}
                            </RadioButtonGroup>
                        </Dialog>
                    )}
                    <EventBadge />
                    <NotificationBadge />
                    {(!!this.props.actions && <ToolbarMenu items={this.props.actions} />)}
                </ToolbarGroup>
            </Toolbar>
        );
    }

    onDialogOpen(dialog) {
        const dialogData = assign({}, this.state[dialog], {open: true});
        this.setState({ [dialog]: dialogData });
    }

    onDialogClose(dialog, value) {
        const dialogData = {
            open: false,
            value: value || this.state[dialog].value
        };
        this.setState({ [dialog]: dialogData });
    }

    onSortByItemChange(event, value) {
        this.props.sortAction && this.props.sortAction({ sort: value });
        this.onDialogClose('sortDialog', value);
    }

    onFilterByItemChange(event, value) {
        this.props.filterAction && this.props.filterAction({ filter: value });
        this.onDialogClose('filterDialog', value);
    }

    goBack() {
        if (this.props.forceBack) {
            if (!!this.props.backTo) {
                window.location = this.props.backTo;
            }
        } else {
            if (this.props.backTo) {
                browserHistory.replace(this.props.backTo);
            }
            browserHistory.goBack();
        }
    }

}

AppToolbar.propTypes = {
    toggleSearchMode: PropTypes.func,
    searchable: PropTypes.bool,
    title: PropTypes.string,
    actions: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    sortOptions: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    filterOptions: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    sortAction: PropTypes.func,
    filterAction: PropTypes.func
};

AppToolbar.defaultProps = {
    backTo:    null,
    forceBack: false,
};

AppToolbar.contextTypes = {
    toggleLeftNav: PropTypes.func.isRequired
};

export default AppToolbar;
